export default __webpack_public_path__ + "static/media/mana4.191d9d98.svg";